import { AxiosRequestConfig } from 'axios';
import { APIService } from '../api';
import { mergeConfig } from '../api/utils';
import { Image } from './Image';
import { Model } from './Model';
import { HasOne, Relations, Relationship } from './Relations';

export class SeoPage extends Model implements Relations<SeoPage> {
    public readonly blueprint = SeoPage;
    public readonly endpoint = APIService.createEndpoint('seo-pages');

    description: string;
    google_verification: string;
    keywords: string;
    page: string;
    platform: string;
    site_name: string;
    title: string;
    favicon_id: number;
    image_id: number;

    image: Image;
    favicon: Image;

    public relations(): Relationship<{ new (): SeoPage }>[] {
        return [HasOne('image', Image, SeoPage), HasOne('favicon', Image, SeoPage)];
    }

    public static async getSeoOfPage(page: string, config?: AxiosRequestConfig) {
        const page$ = new SeoPage();

        const { data } = await page$.endpoint.get(
            '',
            mergeConfig(
                {
                    params: {
                        page,
                        platform: APIService.getPlatform()?.getNamespace(),
                    },
                },
                config,
            ),
        );

        return page$.from(data);
    }
}
